
<template>
  <div class="tf-vue-bg-grey-darker">
    <a href="javascript:void(0)" class="text-white text-decoration-none d-flex align-items-center justify-content-center w-100 h-100 p-2" data-bs-toggle="modal" data-bs-target="#cruiseModal">
     <i class="icon-information"></i>
    </a>
    <div
      id="cruiseModal"
      class="modal"
      tabindex="-1"
      aria-labelledby="cruiseModalLabel"
      aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content p-4">
            <div class="container">
        <h4 class="text-center text-dark">Add Cruise Cover</h4>
        <div>
          <p class="text-dark fw-bold">
            Covers cabin confinement, unused cruise excursions, cruise itinerary change and missed cruise connections. See Section I of the
            <a class="text-dark fw-bolder text-decoration-none" :href="'/travel-insurance/' + policy">Policy Document</a> for full details.
          </p>
        </div>
      </div>

      <div class="text-center my-5">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
      </div>
          </div>
        </div> 
    </div>
  </div>
</template>


<script>
export default {
  props: ['policy', 'quoteType'],
  data() {
    return {
      modalShow:false,
    }
  },
  computed: {
    title() {
      if(this.quoteType === 'SINGLEG') {
        return 'Single Trip Insurance'
      } else {
        return 'Annual Multi-Trip'
      }
    },
  },
  methods: {
    hideModal() {
      this.modalShow = false
    },
  }
}
</script>
<style scoped>
  .container {
    width: 100%;
  }
</style>